import { render, staticRenderFns } from "./UiUserAvatar.vue?vue&type=template&id=41e586b7&scoped=true&"
import script from "./UiUserAvatar.vue?vue&type=script&lang=js&"
export * from "./UiUserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UiUserAvatar.vue?vue&type=style&index=0&id=41e586b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e586b7",
  null
  
)

export default component.exports